import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const getAiSummaryReport = async (aiSummaryReportId) => {
    if (!aiSummaryReportId) {
        return null;
    }

    const { data } = await vlqrApi.get(`aiSummaryReports/${aiSummaryReportId}`)
        .catch((error) => {
            handleError(error);
        });

    return data;
};

const useAiSummaryReport = (aiSummaryReportId) => {
    const { data, refetch, isLoading, isError } = useQuery({
        queryKey: ['aiSummaryReport', aiSummaryReportId],
        queryFn: () => getAiSummaryReport(aiSummaryReportId)
    });

    return { data, refetch, isLoading, isError };
};

export default useAiSummaryReport;
